/**
 * API константы и базовые URL
 */

// Определяем dev режим
export const IS_DEV_MODE = process.env.REACT_APP_DEV_MODE === 'true';

// Хост для API (без протокола)
// Если установлен REACT_APP_API_HOST, используем его, иначе используем дефолтные значения
export const API_HOST = process.env.REACT_APP_API_HOST || (IS_DEV_MODE ? 'localhost:3002' : 'app.ohof.be');

// Определяем протокол в зависимости от среды
const PROTOCOL = 'https';

// Базовый URL для API
export const API_BASE_URL = `${PROTOCOL}://${API_HOST}/api/v1`;

// API базовый URL для публичных эндпоинтов
export const API_PUBLIC_BASE_URL = `${PROTOCOL}://${API_HOST}/api/v1/public`;

// URL для перенаправления на авторизацию
export const LOGIN_URL = `${PROTOCOL}://${API_HOST}/login`;
export const WEBSITE_URL = 'https://ohof.be';

// Email поддержки для ссылки "Забыли пароль" (mailto). Если не задан, открывается письмо без получателя.
export const SUPPORT_EMAIL = 'info@ohof.be';

// Ссылка на оплату (редирект 302 выполняется браузером автоматически)
export const PAYMENT_LINK_PATH = '/private/payment/link';

export const getPaymentLinkUrl = (price: number): string =>
    `${API_BASE_URL}${PAYMENT_LINK_PATH}?price=${price}`;

// URL страницы с деталями тарифов с учетом языка
export const getTariffDetailsUrl = (lang: string): string => `https://ohof.be/${lang}/vo-prices/`;
